import type { FaireProductEntity } from "../../entity_types/product";

export const p_4hzhzrqck3: FaireProductEntity = {
  token: "p_4hzhzrqck3",
  type: "product",
  name: "You Are So Loved Trinket Tray",
  brandToken: "b_cssr21tg",
  brandName: "Glory Haus",
  imageUrl:
    "https://cdn.faire.com/fastly/9ad31e1fea5cc1ed23d8d3bb386df88e1605f5b5dcc9524cb74cd11a0e9d0ea9.jpeg",
  galleryImageUrls: [],
  priceDollars: 11.78,
  description:
    "Offer a daily reminder of love with the You Are So Loved Trinket Tray. Perfect for holding rings, keys, or tiny keepsakes, this tray makes a heartfelt gift for someone special. Whether for birthdays, encouragement, or just because, it’s a simple and beautiful way to show how much you care.\n\n * Original Design \n * ",
  tags: [],
  msrpDollars: 26.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-19T21:22:36.176Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
